import { render, staticRenderFns } from "./CmsIndex.vue?vue&type=template&id=3359d853&scoped=true"
import script from "./CmsIndex.vue?vue&type=script&lang=ts"
export * from "./CmsIndex.vue?vue&type=script&lang=ts"
import style0 from "./CmsIndex.vue?vue&type=style&index=0&id=3359d853&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3359d853",
  null
  
)

export default component.exports